/*
Copyright (c) 2022 COUNTRYSIDE STOVE & CHIMNEY, INC. - ALL RIGHTS RESERVED

UNAUTHORIZED COPYING, MODIFICATION, OR DISTRIBUTION OF THIS SOFTWARE AND ASSOCIATED DOCUMENTATION FILES ("THE SOFTWARE"),
IN ANY MEDIUM IS STRICTLY PROHIBITED
PROPRIETARY AND CONFIDENTIAL
WRITTEN BY BRANDON SULLIVAN <info@empiredistributing.net>, March 2022
*/

import React from 'react';
import {StyleSheet, Platform, Pressable, Keyboard } from 'react-native';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';

const KeyboardAwareScrollViewWithDismiss = (props) => (
<KeyboardAwareScrollView
style={styles.container}
showsVerticalScrollIndicator={false}
showsHorizontalScrollIndicator={false}
keyboardShouldPersistTaps="always">
{Platform.OS === 'web' ? (
<>
{props.children}
</>
) : (
<Pressable
onPress={() => {Keyboard.dismiss()}}>
{props.children}
</Pressable>
)}
</KeyboardAwareScrollView>
)

const styles = StyleSheet.create({
  container: {
    flex: 1,
    width: "100%",
  },
});

export default KeyboardAwareScrollViewWithDismiss;